import React from "react"
import {Button} from "semantic-ui-react"
import PropTypes from "prop-types"

const ListActions = ( { list, product } ) => {
	return (
		<Button.Group className="pl2">
			<Button
				icon="trash"
				onClick={() => {
					list.remove( product )
				}}
			/>
			<Button
				icon="cart"
				onClick={() => {
					list.toCart( product )
				}}
			/>
		</Button.Group>
	)
}
export default ListActions

ListActions.propTypes = {
	list:    PropTypes.object,
	product: PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/components/Product/ProductRowListAction.js